import styled from 'styled-components';

import {colors} from '@app/styles/theme';
import {Link} from '@shared/ui/Link';

export const Container = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    padding: 24px;
    box-sizing: border-box;
    text-align: center;
`;

export const CustomLink = styled(Link)`
    font-size: 20px;
    font-weight: 500;
    color: ${colors.brandPrimary};
`;
